/**
 * お知らせの種類
 */
export namespace NotificationType {
  // 全て
  export const ALL: NotificationMaster = {
    code: 'ALL',
    label: '全て',
  }
  // システム
  export const ADMIN: NotificationMaster = {
    code: 'SYSTEM',
    label: 'システム',
  }
  // 本部
  export const ACADEMY: NotificationMaster = {
    code: 'ACADEMY',
    label: '本部',
  }
  // リスト
  export const LIST: NotificationMaster[] = [ALL, ADMIN, ACADEMY]

  /**
   * codeの値から該当する定数を見つけて返す
   *
   * @param code お知らせタイプのcode
   * @returns お知らせタイプの定数
   */
  export function findByCode(code: string): NotificationMaster | undefined {
    return LIST.find((type) => {
      return type.code === code
    })
  }

  /**
   * お知らせタイプの型
   */
  export type NotificationMaster = {
    /** コード */
    code: string
    /** ラベル */
    label: string
  }
}
